export default __webpack_public_path__ + "assets/images/pricing/3aecd6d23b92c99346e26992d17317fd.png";